// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLinks_container__UZNDD","sending":"FooterLinks_sending__3b0-W"};